import { QueryClient } from "@tanstack/react-query";

/**
 * The Tanstack Query Client for the application.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5,
      // cacheTime: 1000 * 60 * 60 * 24,
    },
  },
});
